import type { ToolSelection } from './types'
import { inputSchema } from './tool-configuration'

export type ActionPolicy = {
    approved: boolean
    audience: 'shared' | 'new_record' | 'personal'
    dynamic_arguments: string[]
    output_paths: string[]
}

export function actionPolicy(tool: ToolSelection): ActionPolicy {
    if (tool.policyJson) {
        return JSON.parse(tool.policyJson)
    }

    return {
        approved: false,
        audience: 'shared',
        dynamic_arguments: tool.allowedDynamicArguments ?? [],
        output_paths: [],
    }
}

// Required inputs that are neither fixed nor filled from the conversation.
export function missingInputs(tool: ToolSelection): string[] {
    const fixed = JSON.parse(tool.fixedArgumentsJson) as Record<string, unknown>
    const dynamic = actionPolicy(tool).dynamic_arguments

    return (inputSchema(tool).required ?? []).filter(
        (field) => !Object.prototype.hasOwnProperty.call(fixed, field) && !dynamic.includes(field)
    )
}

export function policyReady(tool: ToolSelection): boolean {
    const { audience } = actionPolicy(tool)

    if (audience === 'personal') {
        return false
    }

    if (tool.readOnly && audience === 'new_record') {
        return false
    }

    return missingInputs(tool).length === 0
}

export function policyApproved(tool: ToolSelection): boolean {
    return actionPolicy(tool).approved && policyReady(tool)
}
